import { memo } from "react";
import { Circle, Svg } from "react-native-svg";
import type { IconProps } from "@tamagui/helpers-icon";
import { themed } from "@tamagui/helpers-icon";

// The size and width are to compensate by that the path of this svg is
// inherently different, i would avoiding changing it to keep the same.
// @ts-expect-error To preserve the same API as lucide icons because of the
// theme(component) function
const Icon = props => {
  const {
    color = "black",
    size = 30,
    ...otherProps
  } = props;
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...otherProps} data-sentry-element="Svg" data-sentry-component="Icon" data-sentry-source-file="Ellipsis.tsx">
      <Circle cx="12" cy="12" r=".5" fill={color} data-sentry-element="Circle" data-sentry-source-file="Ellipsis.tsx" />
      <Circle cx="19" cy="12" r=".5" fill={color} data-sentry-element="Circle" data-sentry-source-file="Ellipsis.tsx" />
      <Circle cx="5" cy="12" r=".5" fill={color} data-sentry-element="Circle" data-sentry-source-file="Ellipsis.tsx" />
    </Svg>;
};
Icon.displayName = "Ellipsis";
export const Ellipsis = memo<IconProps>(themed(Icon));